import { render, staticRenderFns } from "./ResearchSpliceTrack.vue?vue&type=template&id=ada3a148&"
import script from "./ResearchSpliceTrack.vue?vue&type=script&lang=js&"
export * from "./ResearchSpliceTrack.vue?vue&type=script&lang=js&"
import style0 from "./ResearchSpliceTrack.vue?vue&type=style&index=0&id=ada3a148&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada3a148')) {
      api.createRecord('ada3a148', component.options)
    } else {
      api.reload('ada3a148', component.options)
    }
    module.hot.accept("./ResearchSpliceTrack.vue?vue&type=template&id=ada3a148&", function () {
      api.rerender('ada3a148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSpliceTrack.vue"
export default component.exports